// This file is automatically generated. Do not edit it directly.
import { createClient } from '@supabase/supabase-js';
import type { Database } from './types';

const SUPABASE_URL = "https://prgiqzzstpfipyjjfcpf.supabase.co";
const SUPABASE_PUBLISHABLE_KEY = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InByZ2lxenpzdHBmaXB5ampmY3BmIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NDc4Mjg5OTgsImV4cCI6MjA2MzQwNDk5OH0.Vmzn6zv2pMGt9IDzkUtnD09CU6cy0MM27IKsCop3ZLU";

// Import the supabase client like this:
// import { supabase } from "@/integrations/supabase/client";

export const supabase = createClient<Database>(SUPABASE_URL, SUPABASE_PUBLISHABLE_KEY);